import { useLocation, Navigate } from "react-router-dom";
import { useActiveRedirects } from "@/hooks/useRedirects";

const RedirectHandler = () => {
  const location = useLocation();
  const { data: redirects } = useActiveRedirects();

  if (!redirects) return null;

  const match = redirects.find((r) => r.from_path === location.pathname);
  if (match) {
    return <Navigate to={match.to_path} replace />;
  }

  return null;
};

export default RedirectHandler;
